function hexToRgb(hex: string): Record<string, number> | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function componentToHex(c: number): string {
  const hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
}

function rgbToHex(r: number, g: number, b: number) {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

function generateDifferentColor(rgb: Record<string, number>, step: number) {
  return {
    r: Math.min(Math.max(rgb?.r - step, 0), 255),
    g: Math.min(Math.max(rgb?.g - step, 0), 255),
    b: Math.min(Math.max(rgb?.b - step, 0), 255),
  };
}

export function generateFixedColorGradient(hex: string, step: number = 10): string[] {
  const rgb = hexToRgb(hex);

  return new Array(5)
    .fill(0)
    .map((_, index) => generateDifferentColor(rgb as Record<string, number>, index * -1 * step))
    .map((c) => rgbToHex(c.r, c.g, c.b));
}

export function generateRandomColorGradient(hex: string): string[] {
  const rgb = hexToRgb(hex);
  let step = 0;

  return new Array(5)
    .fill(0)
    .map((_, index) => {
      step += getRandomInt(0, 10);
      return generateDifferentColor(rgb as Record<string, number>, index * -1 * step);
    })
    .map((c) => rgbToHex(c.r, c.g, c.b));
}
